import { css } from "emotion";

export const btn = css`
  &.text-center {
    text-align: center;
    justify-content: center;
  }

  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-radius: 12px;
  background-color: #00aaae;
  color: #FFF;
  font-weight: bold;
  border: none;
  cursor: pointer;
  letter-spacing: 0.3px;

  &:focus {
    outline: none;
  }
`